import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import AppLogo from './AppLogo';

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const close = () => setOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        <Link to="/" className="brand" onClick={close}>
          <AppLogo />
          Construction<span className="brand-accent">&nbsp;Calculator</span>
        </Link>

        <button
          className="menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? '✕' : '☰'}
        </button>

        <nav className={`nav-links ${open ? 'open' : ''}`}>
          <NavLink to="/" end onClick={close}>Home</NavLink>
          <NavLink to="/about" onClick={close}>About</NavLink>
          <NavLink to="/support" onClick={close}>Support</NavLink>
          <NavLink to="/terms" onClick={close}>Terms</NavLink>
          <NavLink to="/privacy" onClick={close}>Privacy</NavLink>
          <NavLink to="/download" className="nav-cta" onClick={close}>
            Download
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
